/* eslint-disable import/prefer-default-export */
export const portalStyles = {
  inlinePortalZIndexIncrement: 10000,
};
